
@file:Suppress("unused")
package tk.mallumo.compose.navigation


import tk.mallumo.compose.navigation.*
import androidx.compose.animation.Crossfade
import androidx.compose.animation.core.FiniteAnimationSpec
import androidx.compose.animation.core.tween
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.*
import tk.mallumo.compose.navigation.ImplNoteUtils.navNode
import tk.mallumo.compose.navigation.viewmodel.ViewModelFactory


private const val navChildKey = "child"

@ExtNavMarker
@Composable
fun NavigationRoot(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    appQuitEnabled: Boolean = true,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    
    setupViewModelFactory()

    val navigation = Navigation.rememberNavigationComposite(
        startupNode = startupNode, 
        startupArgs = startupArgs,
        graph = Graph.Companion.ROOT,
        appQuitEnabled = appQuitEnabled)
     
    val currentNode = navigation.currentNode.collectAsState()

    Crossfade(targetState = currentNode.value, animationSpec = animation) {
        Surface(color = MaterialTheme.colorScheme.background) {
            CompositionLocalProvider(LocalNavigation provides navigation) {
                navNode(node = it)
            }
        }
    }
}

@Composable
private fun setupViewModelFactory() {
	ViewModelFactory.register(ui.GlobalVM::class){ui.GlobalVM()}
	ViewModelFactory.register(ui.app.assign.AppAssignListingVM::class){ui.app.assign.AppAssignListingVM()}
	ViewModelFactory.register(ui.app.assign.detail.AppDetailVM::class){ui.app.assign.detail.AppDetailVM()}
	ViewModelFactory.register(ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorVM::class){ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorVM()}
	ViewModelFactory.register(ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewVM::class){ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewVM()}
	ViewModelFactory.register(ui.app.assign.detail.wheel.editor.AppEditorWheelVM::class){ui.app.assign.detail.wheel.editor.AppEditorWheelVM()}
	ViewModelFactory.register(ui.app.assign.detail.wheel.preview.AppPreviewWheelVM::class){ui.app.assign.detail.wheel.preview.AppPreviewWheelVM()}
	ViewModelFactory.register(ui.app.rss.AppRssListingVM::class){ui.app.rss.AppRssListingVM()}
	ViewModelFactory.register(ui.app.rss.channel.AppRssListingChannelVM::class){ui.app.rss.channel.AppRssListingChannelVM()}
	ViewModelFactory.register(ui.app.rss.instance.AppRssListingInstanceVM::class){ui.app.rss.instance.AppRssListingInstanceVM()}
	ViewModelFactory.register(ui.app.rss.instance.detail.AppRssDetailInstanceVM::class){ui.app.rss.instance.detail.AppRssDetailInstanceVM()}
	ViewModelFactory.register(ui.app.visibility.AppVisibilityListingVM::class){ui.app.visibility.AppVisibilityListingVM()}
	ViewModelFactory.register(ui.campaign.CampaignListingVM::class){ui.campaign.CampaignListingVM()}
	ViewModelFactory.register(ui.campaign.detailv2.editor.CampaignEditorVM::class){ui.campaign.detailv2.editor.CampaignEditorVM()}
	ViewModelFactory.register(ui.campaign.detailv2.preview.CampaignPreviewVM::class){ui.campaign.detailv2.preview.CampaignPreviewVM()}
	ViewModelFactory.register(ui.company.CompanyListingVM::class){ui.company.CompanyListingVM()}
	ViewModelFactory.register(ui.company.detail.CompanyVM::class){ui.company.detail.CompanyVM()}
	ViewModelFactory.register(ui.console.ConsoleVM::class){ui.console.ConsoleVM()}
	ViewModelFactory.register(ui.dashboard.DashboardVM::class){ui.dashboard.DashboardVM()}
	ViewModelFactory.register(ui.device.DeviceListingVM::class){ui.device.DeviceListingVM()}
	ViewModelFactory.register(ui.device.detail.editor.DeviceEditorVM::class){ui.device.detail.editor.DeviceEditorVM()}
	ViewModelFactory.register(ui.device.detail.preview.DevicePreviewVM::class){ui.device.detail.preview.DevicePreviewVM()}
	ViewModelFactory.register(ui.hardware.HardwareListingVM::class){ui.hardware.HardwareListingVM()}
	ViewModelFactory.register(ui.hardware.detail.HardwareDetailVM::class){ui.hardware.detail.HardwareDetailVM()}
	ViewModelFactory.register(ui.home.HomeVM::class){ui.home.HomeVM()}
	ViewModelFactory.register(ui.license.LicenseListingVM::class){ui.license.LicenseListingVM()}
	ViewModelFactory.register(ui.license.detail.LicenseDetailVM::class){ui.license.detail.LicenseDetailVM()}
	ViewModelFactory.register(ui.location.LocationListingVM::class){ui.location.LocationListingVM()}
	ViewModelFactory.register(ui.location.detail.LocationVM::class){ui.location.detail.LocationVM()}
	ViewModelFactory.register(ui.login.LoginVM::class){ui.login.LoginVM()}
	ViewModelFactory.register(ui.report.campaign.ReportCampaignVM::class){ui.report.campaign.ReportCampaignVM()}
	ViewModelFactory.register(ui.report.device.ReportDeviceAliveVM::class){ui.report.device.ReportDeviceAliveVM()}
	ViewModelFactory.register(ui.report.device.ReportDeviceSystemVM::class){ui.report.device.ReportDeviceSystemVM()}
	ViewModelFactory.register(ui.resource.ResourceListingVM::class){ui.resource.ResourceListingVM()}
	ViewModelFactory.register(ui.resource.detail.ResourceVM::class){ui.resource.detail.ResourceVM()}
	ViewModelFactory.register(ui.resource.editor.VisualEditorVM::class){ui.resource.editor.VisualEditorVM()}
	ViewModelFactory.register(ui.resource.icons.IconsListingVM::class){ui.resource.icons.IconsListingVM()}
	ViewModelFactory.register(ui.server.ServerListingVM::class){ui.server.ServerListingVM()}
	ViewModelFactory.register(ui.server.detail.ServerVM::class){ui.server.detail.ServerVM()}
	ViewModelFactory.register(ui.translation.TranslationListingVM::class){ui.translation.TranslationListingVM()}
	ViewModelFactory.register(ui.user.UserListingVM::class){ui.user.UserListingVM()}
	ViewModelFactory.register(ui.user.detail.UserVM::class){ui.user.detail.UserVM()}
}

@ExtNavMarker
@Composable
private fun NavigationChild(
    startupNode: Node,
    startupArgs: ArgumentsNavigation?,
    animation: FiniteAnimationSpec<Float>,
    childKey:String,
    graph:Graph
) {

    val navigation = Navigation.rememberNavigationComposite(startupNode, startupArgs, childKey, graph, false)
    val currentNode = navigation.currentNode.collectAsState()

    Crossfade(targetState = currentNode.value, animationSpec = animation) {
        Surface(color = MaterialTheme.colorScheme.background) {
            CompositionLocalProvider(LocalNavigation provides navigation) {
                navNode(node = it)
            }
        }
    }
}

val Graph.Companion.CompanyContentDashboard get()= Graph("CompanyContentDashboard") 

@ExtNavMarker
@Composable
fun NavigationChildCompanyContentDashboard(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.CompanyContentDashboard]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.CompanyContentDashboard)
}

val Graph.Companion.CompanyContentDevice get()= Graph("CompanyContentDevice") 

@ExtNavMarker
@Composable
fun NavigationChildCompanyContentDevice(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.CompanyContentDevice]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.CompanyContentDevice)
}

val Graph.Companion.CompanyContentLayerBottom get()= Graph("CompanyContentLayerBottom") 

@ExtNavMarker
@Composable
fun NavigationChildCompanyContentLayerBottom(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.CompanyContentLayerBottom]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.CompanyContentLayerBottom)
}

val Graph.Companion.CompanyContentLayerTop get()= Graph("CompanyContentLayerTop") 

@ExtNavMarker
@Composable
fun NavigationChildCompanyContentLayerTop(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.CompanyContentLayerTop]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.CompanyContentLayerTop)
}

val Graph.Companion.CompanyContentLocation get()= Graph("CompanyContentLocation") 

@ExtNavMarker
@Composable
fun NavigationChildCompanyContentLocation(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.CompanyContentLocation]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.CompanyContentLocation)
}

val Graph.Companion.CompanyContentMedia get()= Graph("CompanyContentMedia") 

@ExtNavMarker
@Composable
fun NavigationChildCompanyContentMedia(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.CompanyContentMedia]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.CompanyContentMedia)
}

val Graph.Companion.CompanyContentUser get()= Graph("CompanyContentUser") 

@ExtNavMarker
@Composable
fun NavigationChildCompanyContentUser(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.CompanyContentUser]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.CompanyContentUser)
}

val Graph.Companion.DeviceContentReportSystem get()= Graph("DeviceContentReportSystem") 

@ExtNavMarker
@Composable
fun NavigationChildDeviceContentReportSystem(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.DeviceContentReportSystem]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.DeviceContentReportSystem)
}

val Graph.Companion.HomeContent get()= Graph("HomeContent") 

@ExtNavMarker
@Composable
fun NavigationChildHomeContent(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.HomeContent]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.HomeContent)
}

val Graph.Companion.LocationContent get()= Graph("LocationContent") 

@ExtNavMarker
@Composable
fun NavigationChildLocationContent(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.LocationContent]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.LocationContent)
}

val Graph.Companion.RssListingContent get()= Graph("RssListingContent") 

@ExtNavMarker
@Composable
fun NavigationChildRssListingContent(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.RssListingContent]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.RssListingContent)
}